import t from "react";
import a from "classnames";
import { T as c } from "./index-BB-Wk85r.es.js";
import { u as p } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Chips.css';const m = "Chips-module__chips___xNdHT", i = "Chips-module__chip___jN8Kk", _ = "Chips-module__dark___-bDc9", e = {
  chips: m,
  chip: i,
  dark: _
}, k = ({
  chips: o
}) => {
  const r = p();
  return /* @__PURE__ */ t.createElement("div", { className: e.chips }, o.map((s) => /* @__PURE__ */ t.createElement(
    c.Body3,
    {
      key: s.text,
      className: a([e.chip, r && e.dark]),
      responsive: !0
    },
    s.text
  )));
};
export {
  k as C
};
